(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9316],{

/***/ 49600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77848)


/***/ }),

/***/ 2210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.updateHitPromotions = exports.getHitPromotions = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var getHitPromotions = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var domain, storeId;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            domain = _ref.domain, storeId = _ref.storeId;
            _context.next = 3;
            return _agent.requests.postExternal((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.currentHitEndpoint, {
              domain: domain
            }), {
              storeId: storeId
            });
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getHitPromotions(_x) {
    return _ref2.apply(this, arguments);
  };
}();
exports.getHitPromotions = getHitPromotions;
var updateHitPromotions = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var domain, qty, sku, storeId;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            domain = _ref3.domain, qty = _ref3.qty, sku = _ref3.sku, storeId = _ref3.storeId;
            _context2.next = 3;
            return _agent.requests.putExternal((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.currentHitEndpoint, {
              domain: domain
            }), {
              storeId: storeId,
              qty: qty,
              sku: sku
            });
          case 3:
            return _context2.abrupt("return", _context2.sent);
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function updateHitPromotions(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
exports.updateHitPromotions = updateHitPromotions;

/***/ }),

/***/ 51129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var _mapProductDataNew = _interopRequireDefault(__webpack_require__(69729));
var productWithVariant = function productWithVariant(products, sku) {
  var product = products.find(function (product) {
    return product.sku === sku;
  });
  product.otherVariants = products.filter(function (product) {
    return product.sku !== sku;
  });
  return product;
};
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(sku, url, lang) {
    var productFamily, product, invalidProduct;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!url) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return _agent.requests.get(url, true,
            //global.__appConfig__.elasticEnabled,
            null, lang);
          case 3:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;
          case 6:
            _context.next = 8;
            return _agent.requests.get((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.productFamilyUrl, {
              sku: encodeURI(sku)
            }), true,
            //global.__appConfig__.elasticEnabled,
            null, lang);
          case 8:
            _context.t0 = _context.sent;
          case 9:
            productFamily = _context.t0;
            invalidProduct = function invalidProduct(productFamily) {
              return Object.keys(productFamily).length === 0 && productFamily.constructor === Object || (productFamily === null || productFamily === void 0 ? void 0 : productFamily.length) !== undefined;
            };
            product = invalidProduct(productFamily) ? {} : productWithVariant((0, _mapProductDataNew["default"])(productFamily), url ? productFamily.sku : sku);
            if (!(Object.keys(product).length === 0)) {
              _context.next = 15;
              break;
            }
            console.log("Error productFamily  sku: ".concat(sku, ", url: ").concat(url, ", lang: ").concat(lang.language, ", domain: ").concat(lang.domain, ", host: ").concat(lang.host));
            return _context.abrupt("return", {
              product: null,
              error: {
                statusCode: 404
              },
              categoryId: 0
            });
          case 15:
            return _context.abrupt("return", {
              product: product,
              categoryId: product.categoryId !== undefined ? product.categoryId : 0
            });
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 11424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "useProduct", ({
  enumerable: true,
  get: function get() {
    return _useProduct["default"];
  }
}));
Object.defineProperty(exports, "fetcher", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _useProduct = _interopRequireDefault(__webpack_require__(46548));
var _fetcher = _interopRequireDefault(__webpack_require__(51129));

/***/ }),

/***/ 46548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(51129));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var _LanguageProvider = __webpack_require__(8989);
var useProduct = function useProduct(sku, url, lang, fetchedProduct) {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  return (0, _swr["default"])([sku, url, language, "useProduct"], _fetcher["default"], {
    initialData: fetchedProduct
  });
};
var _default = useProduct;
exports["default"] = _default;

/***/ }),

/***/ 74970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _useClock2 = __webpack_require__(6738);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _HitProvider = __webpack_require__(17090);
var _timeBox = _interopRequireDefault(__webpack_require__(72097));
var __jsx = _react["default"].createElement;
var Clock = function Clock(_ref) {
  var _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel;
  var translations = {
    offerEnds: (0, _langLibrary["default"])("Offer ends"),
    offerStart: (0, _langLibrary["default"])("Offer start"),
    hours: (0, _langLibrary["default"])("hours hit"),
    minutes: (0, _langLibrary["default"])("minutes hit"),
    seconds: (0, _langLibrary["default"])("seconds hit")
  };
  var _useHit = (0, _HitProvider.useHit)(),
    isActive = _useHit.isActive;
  var _useClock = (0, _useClock2.useClock)(),
    hour = _useClock.hour,
    min = _useClock.min,
    sec = _useClock.sec;
  return __jsx(_react["default"].Fragment, null, showLabel ? __jsx(_Box["default"], {
    sx: {
      font: "base_sans_bold",
      color: "white",
      my: "s8"
    }
  }, isActive ? translations.offerEnds : translations.offerStart) : __jsx(_Box["default"], {
    sx: {
      height: 20
    }
  }), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      font: "sans_serif_40",
      color: "white",
      marginTop: "s6",
      px: 10
    }
  }, __jsx(_timeBox["default"], {
    numberOrText: hour
  }), __jsx(_timeBox["default"], {
    numberOrText: min
  }), __jsx(_timeBox["default"], {
    numberOrText: sec
  })), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      font: "xs_caps",
      fontSize: 12,
      color: "white",
      px: 10,
      mt: 10
    }
  }, __jsx(_timeBox["default"], {
    numberOrText: translations.hours,
    background: false
  }), __jsx(_timeBox["default"], {
    numberOrText: translations.minutes,
    background: false
  }), __jsx(_timeBox["default"], {
    numberOrText: translations.seconds,
    background: false
  })));
};
var _default = Clock;
exports["default"] = _default;

/***/ }),

/***/ 72097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var __jsx = _react["default"].createElement;
var TimeBox = function TimeBox(_ref) {
  var numberOrText = _ref.numberOrText,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 70 : _ref$width,
    separator = _ref.separator;
  return __jsx(_Box["default"], {
    as: "span",
    sx: {
      width: width,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, numberOrText !== null && numberOrText !== void 0 ? numberOrText : "", separator ? __jsx(_Box["default"], {
    as: "span",
    sx: {
      px: "s3"
    }
  }, separator) : "");
};
var _default = TimeBox;
exports["default"] = _default;

/***/ }),

/***/ 6738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.timeBetweenStartAndEnd = exports.useClock = void 0;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _react = __webpack_require__(34885);
var _HitProvider = __webpack_require__(17090);
var getTimeFromString = function getTimeFromString() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "0:0:0";
  var _time$split = time.split(":"),
    _time$split2 = (0, _slicedToArray2["default"])(_time$split, 3),
    hoursStr = _time$split2[0],
    minutesStr = _time$split2[1],
    secondsStr = _time$split2[2];
  return {
    hours: parseInt(hoursStr, 10),
    minutes: parseInt(minutesStr, 10),
    seconds: parseInt(secondsStr, 10)
  };
};
var timeBetweenStartAndEnd = function timeBetweenStartAndEnd(currentDate) {
  var _currentDate;
  currentDate = (_currentDate = currentDate) !== null && _currentDate !== void 0 ? _currentDate : new Date();
  var _getTimeFromString = getTimeFromString(__webpack_require__.g.__appConfig__.currentHitStartTime),
    hoursStart = _getTimeFromString.hours,
    minutesStart = _getTimeFromString.minutes,
    secondsStart = _getTimeFromString.seconds;
  var _getTimeFromString2 = getTimeFromString(__webpack_require__.g.__appConfig__.currentHitEndTime),
    hoursEnd = _getTimeFromString2.hours,
    minutesEnd = _getTimeFromString2.minutes,
    secondsEnd = _getTimeFromString2.seconds;
  var hours = currentDate.getHours();
  var minutes = currentDate.getMinutes();
  var seconds = currentDate.getSeconds();
  var timeEqualOrGraterFromStart = function timeEqualOrGraterFromStart() {
    if (hours > hoursStart) {
      return true;
    }
    if (hours === hoursStart && minutes > minutesStart) {
      return true;
    }
    if (hours === hoursStart && minutes === minutesStart && seconds >= secondsStart) {
      return true;
    }
    return false;
  };
  var timeEqualOrSmallerFromEnd = function timeEqualOrSmallerFromEnd() {
    if (hours < hoursEnd) {
      return true;
    }
    if (hours === hoursEnd && minutes < minutesEnd) {
      return true;
    }
    if (hours === hoursEnd && minutes === minutesEnd && seconds <= secondsEnd) {
      return true;
    }
    return false;
  };
  return {
    isTimeBetweenStartAndEnd: timeEqualOrSmallerFromEnd() && timeEqualOrGraterFromStart(),
    hoursStart: hoursStart,
    minutesStart: minutesStart,
    secondsStart: secondsStart,
    hoursEnd: hoursEnd,
    minutesEnd: minutesEnd,
    secondsEnd: secondsEnd
  };
};
exports.timeBetweenStartAndEnd = timeBetweenStartAndEnd;
var useClock = function useClock() {
  var _useHit = (0, _HitProvider.useHit)(),
    isActive = _useHit.isActive,
    setIsActive = _useHit.setIsActive;
  var _useState = (0, _react.useState)({
      hour: undefined,
      min: undefined,
      sec: undefined
    }),
    remainingTime = _useState[0],
    setRemainingTime = _useState[1];
  var isFirst = (0, _react.useRef)(false);
  var isWorking = (0, _react.useRef)(isActive);
  var getDate = function getDate() {
    var currentDate = new Date();
    var targetTime = new Date(currentDate);
    var _timeBetweenStartAndE = timeBetweenStartAndEnd(currentDate),
      isTimeBetweenStartAndEnd = _timeBetweenStartAndE.isTimeBetweenStartAndEnd,
      hoursStart = _timeBetweenStartAndE.hoursStart,
      minutesStart = _timeBetweenStartAndE.minutesStart,
      secondsStart = _timeBetweenStartAndE.secondsStart,
      hoursEnd = _timeBetweenStartAndE.hoursEnd,
      minutesEnd = _timeBetweenStartAndE.minutesEnd,
      secondsEnd = _timeBetweenStartAndE.secondsEnd;
    if (!isTimeBetweenStartAndEnd && isWorking.current) {
      setIsActive(false);
      isWorking.current = false;
    }
    if (isTimeBetweenStartAndEnd && !isWorking.current) {
      setIsActive(true);
      isWorking.current = true;
    }
    if (isWorking.current) {
      targetTime.setHours(hoursEnd, minutesEnd, secondsEnd, 0);
    } else {
      targetTime.setDate(targetTime.getDate() + 1);
      targetTime.setHours(hoursStart, minutesStart, secondsStart, 0);
    }
    var timeDifferenceMs = targetTime - currentDate;
    var hour = Math.floor(timeDifferenceMs / (1000 * 60 * 60));
    var min = Math.floor(timeDifferenceMs % (1000 * 60 * 60) / (1000 * 60));
    var sec = Math.floor(timeDifferenceMs % (1000 * 60) / 1000);
    if (hour < 0) {
      return {
        hour: 0,
        min: 0,
        sec: 0
      };
    }
    return {
      hour: hour,
      min: min,
      sec: sec
    };
  };
  (0, _react.useEffect)(function () {
    if (!isFirst.current) {
      setRemainingTime(function (prev) {
        return getDate();
      });
      isFirst.current = true;
    }
    var intervalId = setInterval(function () {
      setRemainingTime(function (prev) {
        return getDate();
      });
    }, 1000);
    return function () {
      clearInterval(intervalId);
    };
  }, []);
  return (remainingTime === null || remainingTime === void 0 ? void 0 : remainingTime.hour) === undefined ? remainingTime : addZeroToNumber(remainingTime);
};
exports.useClock = useClock;
var addZeroToNumber = function addZeroToNumber(values) {
  return Object.entries(values).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    acc[key] = String(value).padStart(2, "0");
    return acc;
  }, {});
};

/***/ }),

/***/ 2329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var __jsx = _react["default"].createElement;
var SoldOut = function SoldOut() {
  var translations = {
    soldOut: (0, _langLibrary["default"])("sold out")
  };
  return __jsx(_react["default"].Fragment, null, translations.soldOut);
};
var _default = SoldOut;
exports["default"] = _default;

/***/ }),

/***/ 269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _useSoldCounter2 = _interopRequireDefault(__webpack_require__(34069));
var _SoldOut = _interopRequireDefault(__webpack_require__(2329));
var _SoldProgressBar = _interopRequireDefault(__webpack_require__(96354));
var _HitProvider = __webpack_require__(17090);
var __jsx = _react["default"].createElement;
var ProductsCounter = function ProductsCounter(props) {
  var progressActive = props.progressActive;
  var _useHit = (0, _HitProvider.useHit)(),
    isActive = _useHit.isActive;
  var _useSoldCounter = (0, _useSoldCounter2["default"])(),
    sold = _useSoldCounter.sold,
    left = _useSoldCounter.left;
  if (!isActive) {
    return __jsx(_SoldOut["default"], null);
  }
  return progressActive && left < __webpack_require__.g.__appConfig__.showHitProgressNumber && __jsx(_SoldProgressBar["default"], {
    sold: sold,
    left: left
  });
};
var _default = ProductsCounter;
exports["default"] = _default;

/***/ }),

/***/ 34069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = __webpack_require__(34885);
var _HitProvider = __webpack_require__(17090);
var _useHitPromotions = __webpack_require__(2210);
var _LanguageProvider = __webpack_require__(8989);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSoldCounter = function useSoldCounter() {
  var _global$__appConfig__;
  var _useHit = (0, _HitProvider.useHit)(),
    isProductPageHit = _useHit.isProductPageHit,
    sale = _useHit.sale,
    setSale = _useHit.setSale,
    isActive = _useHit.isActive,
    setIsActive = _useHit.setIsActive;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var storeId = (_global$__appConfig__ = __webpack_require__.g.__appConfig__.storeIds) === null || _global$__appConfig__ === void 0 ? void 0 : _global$__appConfig__[language.language];
  var firstRender = (0, _react.useRef)({
    isLoading: false,
    isProductPageHit: isProductPageHit,
    intervalId: null,
    sale: sale
  });
  var getSku = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _ref2, _hitResult$qtyForSale, _firstRender$current$, _firstRender$current$2, hitResult, saleTemporary;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(!isActive && isProductPageHit || firstRender.current.isLoading)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              firstRender.current.isLoading = true;
              _context.next = 6;
              return (0, _useHitPromotions.getHitPromotions)({
                storeId: storeId,
                domain: language.domain
              });
            case 6:
              hitResult = _context.sent;
              firstRender.current.isLoading = false;
              if (hitResult) {
                _context.next = 10;
                break;
              }
              throw "no hit result";
            case 10:
              saleTemporary = {
                left: (_ref2 = hitResult.maxQtyPerDay - hitResult.qtyForSale) !== null && _ref2 !== void 0 ? _ref2 : 0,
                sold: (_hitResult$qtyForSale = hitResult.qtyForSale) !== null && _hitResult$qtyForSale !== void 0 ? _hitResult$qtyForSale : 0,
                sku: hitResult.sku,
                price: hitResult.price,
                maxQtyPerClient: hitResult.qtyPerClient
              };
              if (!((hitResult.qtyForSale >= hitResult.maxQtyPerDay || (hitResult === null || hitResult === void 0 ? void 0 : hitResult.waitForNext) === true) && isActive)) {
                _context.next = 15;
                break;
              }
              setSale(saleTemporary);
              setIsActive(false);
              return _context.abrupt("return");
            case 15:
              if (!(((_firstRender$current$ = firstRender.current.sale) === null || _firstRender$current$ === void 0 ? void 0 : _firstRender$current$.left) === saleTemporary.left && ((_firstRender$current$2 = firstRender.current.sale) === null || _firstRender$current$2 === void 0 ? void 0 : _firstRender$current$2.sku) === saleTemporary.sku)) {
                _context.next = 17;
                break;
              }
              return _context.abrupt("return");
            case 17:
              firstRender.current.sale = saleTemporary;
              setSale(saleTemporary);
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              console.log("Hit get current hit error:", _context.t0);
            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 21]]);
    }));
    return function getSku() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (sale === null) {
      getSku()["catch"](console.error);
    }
    var intervalId;
    if (isActive) {
      intervalId = setInterval(function () {
        getSku()["catch"](console.error);
      }, __webpack_require__.g.__appConfig__.currentHitRefreshSaleInterval);
    }
    firstRender.current.intervalId = intervalId;
    if (!isActive && firstRender.current.intervalId) {
      clearInterval(intervalId);
    }
    return function () {
      clearInterval(firstRender.current.intervalId);
    };
  }, [isActive]);
  return _objectSpread({}, sale);
};
var _default = useSoldCounter;
exports["default"] = _default;

/***/ }),

/***/ 96354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _percentPart = _interopRequireDefault(__webpack_require__(96453));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var __jsx = _react["default"].createElement;
var SoldProgressBar = function SoldProgressBar(_ref) {
  var sold = _ref.sold,
    left = _ref.left;
  var translations = {
    left: (0, _langLibrary["default"])("left hits"),
    sold: (0, _langLibrary["default"])("sold hits")
  };
  var percentWidth = !sold ? 100 : (0, _percentPart["default"])(sold, sold + left);
  percentWidth = percentWidth === 100 ? percentWidth : 100 - percentWidth;
  return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      textAlign: "center"
    }
  }, __jsx(_Box["default"], {
    sx: {
      flexBasis: "100%",
      minHeight: "4px",
      maxHeight: "4px",
      borderColor: "#CFCEC5",
      borderLeftStyle: "solid",
      borderRightStyle: "solid",
      borderWidth: "1px",
      mt: "s8",
      mb: "s6",
      bg: "#CFCEC5",
      position: "relative",
      zIndex: "1"
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: "3px",
      backgroundColor: "active",
      position: "absolute",
      zIndex: "2",
      maxWidth: "100%",
      width: percentWidth + "%",
      transition: "width 0.2s ease-out"
    }
  }))), __jsx(_Box["default"], {
    sx: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      font: "xs_caps",
      color: "white",
      textTransform: "lowercase",
      backgroundColor: "none"
    }
  }, __jsx(_Box["default"], {
    as: "span"
  }, translations.left, " ", left), __jsx(_Box["default"], {
    as: "span"
  }, translations.sold, " ", sold)));
};
var _default = SoldProgressBar;
exports["default"] = _default;

/***/ }),

/***/ 17090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.HitProvider = exports.useHit = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _useClock = __webpack_require__(6738);
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var HitContext = /*#__PURE__*/_react["default"].createContext();
var HitProvider = function HitProvider(_ref) {
  var children = _ref.children,
    isProductPageHit = _ref.isProductPageHit;
  var _timeBetweenStartAndE = (0, _useClock.timeBetweenStartAndEnd)(),
    isTimeBetweenStartAndEnd = _timeBetweenStartAndE.isTimeBetweenStartAndEnd;
  var _useState = (0, _react.useState)(null),
    hitProduct = _useState[0],
    setHitProduct = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    sale = _useState2[0],
    setSale = _useState2[1];
  var _useState3 = (0, _react.useState)(isTimeBetweenStartAndEnd),
    isActive = _useState3[0],
    setIsActive = _useState3[1];
  return __jsx(HitContext.Provider, {
    value: {
      isActive: isActive,
      setIsActive: setIsActive,
      hitProduct: hitProduct,
      setHitProduct: setHitProduct,
      sale: sale,
      isProductPageHit: isProductPageHit,
      setSale: setSale
    }
  }, children);
};
exports.HitProvider = HitProvider;
var useHit = function useHit() {
  var isProductPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (isProductPage) {
    return {
      hitProduct: null,
      sale: null
    };
  }
  var context = (0, _react.useContext)(HitContext);
  if (!context) {
    throw new Error("useHit must be used within a HitProvider");
  }
  return context;
};
exports.useHit = useHit;

/***/ }),

/***/ 36880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Op = exports.ZP = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _head = _interopRequireDefault(__webpack_require__(49600));
var _router = __webpack_require__(53746);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _LanguageProvider = __webpack_require__(8989);
var _useSalesmanago = _interopRequireDefault(__webpack_require__(54569));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var META_TYPE = {
  searchResults: "product-search",
  productPage: "product-page",
  categoryPage: "category-page, product-list"
};
exports.Op = META_TYPE;
Object.freeze(META_TYPE);
var defaultProps = {
  siteName: "Dajar"
};
var MetaTags = function MetaTags(props) {
  var page = props.page,
    sku = props.sku,
    passedUrl = props.url,
    productRegularPrice = props.productRegularPrice,
    productSpecialPrice = props.productSpecialPrice,
    productAvailability = props.productAvailability,
    productBrand = props.productBrand,
    productCategory = props.productCategory,
    currentPageNumber = props.currentPageNumber,
    tags = props.tags,
    noFollow = props.noFollow,
    domains = props.domains,
    _props$siteName = props.siteName,
    siteName = _props$siteName === void 0 ? defaultProps.siteName : _props$siteName;
  var translations = {
    page: (0, _langLibrary["default"])("page")
  };
  var singleDomain = props.singleDomain,
    title = props.title,
    description = props.description,
    imageUrl = props.imageUrl;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  singleDomain = singleDomain ? "https://".concat(singleDomain) : null;
  var baseUrl = domains ? "https://".concat(Object.keys(domains).find(function (domain) {
    return domains[domain] === language.language;
  })) : singleDomain;
  var router = (0, _router.useRouter)();
  var routePaths = router !== null && router !== void 0 && router.asPath ? router.asPath.split("?") : [];
  var defaultOgImage = "/static/images/dajar-og-image.jpg";
  if (currentPageNumber) {
    title += "| ".concat(translations.page, " ").concat(currentPageNumber);
  }
  var tagsPrefix = tags && tags.length > 3 ? tags.join(", ") + "... - " : tags && tags.length > 0 ? tags.join(", ") + " - " : "";
  title = tagsPrefix + title;
  description = tagsPrefix + description;
  var url = noFollow ? baseUrl + passedUrl : baseUrl + "".concat(routePaths[0]);
  imageUrl = imageUrl === undefined || page === META_TYPE.searchResults ? baseUrl + defaultOgImage : baseUrl + imageUrl;
  (0, _react.useEffect)(function () {
    handleSalesmanagoEvent("VISIT");
  }, [title]);
  if (title !== "undefined") {
    return __jsx(_head["default"], null, __jsx("title", null, title), __jsx("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), __jsx("meta", {
      name: "robots",
      content: page === META_TYPE.searchResults || noFollow ? "noindex, nofollow" : "index, follow"
    }), __jsx("link", {
      rel: "canonical",
      href: url
    }), __jsx("meta", {
      name: "title",
      content: title
    }), __jsx("meta", {
      name: "description",
      content: description
    }), __jsx("meta", {
      property: "og:site_name",
      content: siteName
    }), __jsx("meta", {
      property: "og:locale",
      content: language === null || language === void 0 ? void 0 : language.language
    }), __jsx("meta", {
      property: "og:title",
      content: title
    }), __jsx("meta", {
      property: "og:description",
      content: description
    }), __jsx("meta", {
      property: "og:type",
      content: page === META_TYPE.productPage ? "product" : "website"
    }), __jsx("meta", {
      property: "og:url",
      content: url
    }), __jsx("meta", {
      property: "og:image",
      content: imageUrl
    }), __jsx("meta", {
      property: "og:image:alt",
      content: title
    }), page === META_TYPE.productPage && __jsx(_react["default"].Fragment, null, __jsx("meta", {
      property: "product:condition",
      content: "new"
    }), __jsx("meta", {
      property: "product:availability",
      content: productAvailability
    }), __jsx("meta", {
      property: "product:original_price:amount",
      content: productRegularPrice
    }), __jsx("meta", {
      property: "product:original_price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:price:amount",
      content: productSpecialPrice
    }), __jsx("meta", {
      property: "product:price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:retailer_item_id",
      content: sku
    }), __jsx("meta", {
      property: "product:brand",
      content: productBrand
    }), __jsx("meta", {
      property: "product:category",
      content: productCategory
    })), __jsx("meta", {
      property: "twitter:card",
      content: page === META_TYPE.productPage ? "product" : "summary_large_image"
    }), __jsx("meta", {
      property: "twitter:site",
      content: "@DAJARpl"
    }), __jsx("meta", {
      property: "twitter:url",
      content: url
    }), __jsx("meta", {
      property: "twitter:title",
      content: title
    }), __jsx("meta", {
      property: "twitter:description",
      content: description.slice(0, 100)
    }), __jsx("meta", {
      property: "twitter:image",
      content: imageUrl
    }));
  } else {
    return __jsx(_head["default"], null);
  }
};
var _default = MetaTags;
exports.ZP = _default;

/***/ }),

/***/ 96453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var percentPart = function percentPart(part, total) {
  return Math.floor(part / total * 100);
};
var _default = percentPart;
exports["default"] = _default;

/***/ }),

/***/ 39125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MetaTags; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../components-new/dist/MetaTags/index.js
var MetaTags = __webpack_require__(36880);
;// CONCATENATED MODULE: ./conf/lang.domains.json
var lang_domains_namespaceObject = JSON.parse('{"dajar.cz":"cz","dajar.de":"de","dajar.es":"es","dajar.fr":"fr","dajar.pl":"pl","dajar.it":"it","dajar.co.uk":"gb","dajar.ro":"ro","dajar.se":"se","dajar.sk":"sk"}');
;// CONCATENATED MODULE: ./src/components/MetaTags/index.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MetaTags_MetaTags = function(props) {
    var propsExt = _objectSpread({}, props, {
        domains: lang_domains_namespaceObject
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.ZP, _objectSpread({}, propsExt)));
};
/* harmony default export */ var components_MetaTags = (MetaTags_MetaTags);


/***/ })

}]);